<ng-container *ngIf="commonResource$ | async as commonResource">
  <div class="row mt-sm-5">
    <div class="col-6">
      <button
        (click)="previous()"
        class="btn btn-block btn-iconed btn-iconed-default-white btn-iconed-left w-auto"
      >
        {{ commonResource['BackButton']
        }}<i class="btn-icon ifc-custom ifc-arrow-left"></i>
      </button>
    </div>
    <div class="col-6">
      <button
        *ngIf="!hideNext"
        (click)="next()"
        type="button"
        class="btn btn-block btn-iconed btn-iconed-primary w-auto float-right"
      >
        {{ commonResource['ContinueButton'] }}
        <i class="btn-icon ifc-custom ifc-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</ng-container>
